/**
 * @generated SignedSource<<8da4d5c1c37014ec5a6205a97d3b4550>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CateringOptionsListRow_cateringOption$data = {
  readonly displayInSearch: boolean;
  readonly etgKey: string | null;
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SortableEntityTableRow_entity">;
  readonly " $fragmentType": "CateringOptionsListRow_cateringOption";
};
export type CateringOptionsListRow_cateringOption$key = {
  readonly " $data"?: CateringOptionsListRow_cateringOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"CateringOptionsListRow_cateringOption">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CateringOptionsListRow_cateringOption",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "etgKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayInSearch",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SortableEntityTableRow_entity"
    }
  ],
  "type": "CateringOption",
  "abstractKey": null
};

(node as any).hash = "ed7b63436d369a19c7da6650ab6f6548";

export default node;
